import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import {Box, TextField} from "@mui/material";
import 'dayjs/locale/en-gb';
import {FormIds} from "../../../constants";
import {useTranslation} from "react-i18next";
import {useUserRole} from "../../../utils/UserRoleContext";

export interface NetECGProductFormValues {
  serialNumber: string,
  serialNumberChargingDock: string,
  batchNumber: string,
  evaluationSoftware: string
}

export interface NetECGProductFormProps {
  onSubmit: (data: NetECGProductFormValues) => void,
  /** This function updates the dirty state in the parents component */
  updateDirty: (dirty: boolean) => void,
  defaultValues: NetECGProductFormValues
}

export default function NetECGProductForm({onSubmit, defaultValues, updateDirty}: Readonly<NetECGProductFormProps>) {

  const form = useForm<NetECGProductFormValues>({
    defaultValues
  })
  const {register, handleSubmit, formState} = form
  const {errors} = formState

  const {t} = useTranslation()
  const {isAdmin} = useUserRole();

  useEffect(() => {
    updateDirty(form.formState.isDirty)
  }, [form.formState.isDirty])

  return (
    <form id={FormIds.updateNetECG} onSubmit={handleSubmit(onSubmit)} noValidate>
      <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            gap: 2,
            marginTop: 2,
            paddingTop: 2,
            paddingLeft: 2,
            paddingRight: 2,
            flexFlow: 'row wrap'
          }}>
        <Box sx={{display: 'flex', flexWrap: 'unset', flexDirection: 'column', width: '100%'}}>
          <Box sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
            <TextField
              id={"serialNumber"}
              variant="standard"
              label={t('objects.products.netecg.serialNumber')}
              {...register("serialNumber", {
                required: t('objects.products.netecg.requiredMessage', {obj: t('objects.products.netecg.serialNumber')})
              })}
              required
              sx={{marginTop: 1}}
              error={!!errors.serialNumber}
              helperText={errors.serialNumber?.message}
              disabled={!isAdmin}
            />

            <TextField
              id={"evaluationSoftware"}
              variant="standard"
              label={t('objects.products.netecg.evaluationSoftware')}
              {...register("evaluationSoftware", {
                required: t('objects.products.netecg.requiredMessage', {obj: t('objects.products.netecg.evaluationSoftware')})
              })}
              required
              sx={{marginTop: 1}}
              error={!!errors.evaluationSoftware}
              helperText={errors.evaluationSoftware?.message}
              disabled={!isAdmin}
            />

            <TextField
              id={"batchNumber"}
              variant="standard"
              label={t('objects.products.netecg.batchNumber')}
              {...register("batchNumber", {
                required: t('objects.products.netecg.requiredMessage', {obj: t('objects.products.netecg.batchNumber')})
              })}
              required
              sx={{marginTop: 1}}
              error={!!errors.batchNumber}
              helperText={errors.batchNumber?.message}
              disabled={!isAdmin}
            />

            <TextField
              id={"serialNumberChargingDock"}
              variant="standard"
              label={t('objects.products.netecg.serialNumberChargingDock')}
              {...register("serialNumberChargingDock", {
                required: t('objects.products.netecg.requiredMessage', {obj: t('objects.products.netecg.serialNumberChargingDock')})
              })}
              required
              sx={{marginTop: 1}}
              error={!!errors.serialNumberChargingDock}
              helperText={errors.serialNumberChargingDock?.message}
              disabled={!isAdmin}
            />
          </Box>
        </Box>
      </Box>
    </form>
  )
}
